import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _STAR_SIZE_MAP, _STAR_FILL_MAP;
import { Star12 } from '../components/Star/Star12';
import { Star16 } from '../components/Star/Star16';
import { EStarSize, EStarTheme } from '../types/star';
export var STAR_SIZE_MAP = (_STAR_SIZE_MAP = {}, _defineProperty(_STAR_SIZE_MAP, EStarSize.S, Star12), _defineProperty(_STAR_SIZE_MAP, EStarSize.M, Star16), _STAR_SIZE_MAP);
export var STAR_FILL_MAP = (_STAR_FILL_MAP = {}, _defineProperty(_STAR_FILL_MAP, EStarTheme.Filled, '#ff7e00'), _defineProperty(_STAR_FILL_MAP, EStarTheme.NotFilled, '#ced1d7'), _STAR_FILL_MAP);